import {
  type PickStateRefValues,
  withCompController,
} from '@wix/editor-elements-integrations';
import type {
  ISelectionTagsListControllerProps,
  ISelectionTagsListMapperProps,
  ISelectionTagsListProps,
} from '../SelectionTagsList.types';
import { isExperimentOpen } from '@wix/editor-elements-common-utils';

export default withCompController<
  ISelectionTagsListMapperProps,
  ISelectionTagsListControllerProps,
  ISelectionTagsListProps,
  PickStateRefValues<'experiments'>
>(({ mapperProps, controllerUtils, stateValues }) => {
  const { experiments = {} } = stateValues;
  const isClassNameToRootEnabled = isExperimentOpen(
    experiments,
    'specs.thunderbolt.isClassNameToRootEnabled',
  );

  return {
    ...mapperProps,
    onChange: nextValue => {
      controllerUtils.updateProps({ value: nextValue });
    },
    isClassNameToRootEnabled,
  };
});
